import React from "react";
import useAxios from "axios-hooks";
import OptionsTable from "../../../../../Table/OptionsTable";

const columns = [
  {
    key: "column1",
    name: "Course ID",
    fieldName: "cobrandId",
    maxWidth: 20,
    isResizable: true,
  },
  {
    key: "column2",
    name: "Name",
    fieldName: "name",
    minWidth: 200,
    isResizable: true,
  },
];

const CobrandTable = ({ setOptionTable }) => {
  const [{ data, loading }] = useAxios({ url: `/cobrand/cobrands` });

  return (
    <OptionsTable
      columns={columns}
      data={data}
      fieldName="cobrand"
      objectKey="cobrandId"
      loading={loading}
      setOptionTable={setOptionTable}
      title="Cobrands"
      multiSelect
    />
  );
};

export default CobrandTable;
